namespace Matrix.Workflow {
    export namespace ClientFunctionService {
        export const baseUrl = 'Workflow/ClientFunction';

        export declare function Update(request: Serenity.SaveRequest<ClientFunctionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ClientFunctionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ClientFunctionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Invoke(request: ClientFunctionInvokeRequest, onSuccess?: (response: ClientFunctionInvokeResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetModel(request: ClientFunctionGetModelRequest, onSuccess?: (response: ClientFunctionGetModelResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "Workflow/ClientFunction/Update",
            Retrieve = "Workflow/ClientFunction/Retrieve",
            List = "Workflow/ClientFunction/List",
            Invoke = "Workflow/ClientFunction/Invoke",
            GetModel = "Workflow/ClientFunction/GetModel"
        }

        [
            'Update', 
            'Retrieve', 
            'List', 
            'Invoke', 
            'GetModel'
        ].forEach(x => {
            (<any>ClientFunctionService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
